import { Injectable } from '@angular/core';
import { LogResponse } from '../../../protos/generated/admin.pb';

@Injectable({
  providedIn: 'root'
})
export class LogTransferService {
  private selectedLog: LogResponse | null = null;

  setLog(log: LogResponse): void {
    this.selectedLog = log;
  }

  getLog(): LogResponse | null {
    return this.selectedLog;
  }

  clear(): void {
    this.selectedLog = null;
  }
}
